import React from 'react'

function InvoiceStatistics() {
  return (
    <div>InvoiceStatistics</div>
  )
}

export default InvoiceStatistics